"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewRelicAnalytics = NewRelicAnalytics;
exports.dispatchNewRelicAddToBasketEvent = dispatchNewRelicAddToBasketEvent;
var _react = require("react");
function NewRelicAnalytics(_ref) {
  var skuId = _ref.skuId,
    pimProductId = _ref.pimProductId,
    configName = _ref.configName,
    interaction = _ref.interaction;
  var skuRef = (0, _react.useRef)(skuId);
  (0, _react.useEffect)(function () {
    if (skuRef.current !== skuId) {
      dispatchQuickViewUpdatedEvent(pimProductId, configName, interaction);
      skuRef.current = skuId;
      return;
    }

    // These will all only be called if sku hasn't changed,
    // which should mean only on qv open.
    dispatchQuickViewOpenedEvent(pimProductId, configName);
  }, [skuId]);
  return null;
}
function dispatchQuickViewOpenedEvent(pimProductId, configName, interaction) {
  addPageAction('quickViewDisplayed', {
    pimProductId: pimProductId,
    configName: configName,
    interaction: interaction,
    version: 'jlds',
    duration: getDurationFor('quickViewDisplayed')
  });
}
function dispatchQuickViewUpdatedEvent(pimProductId, configName) {
  addPageAction('quickViewChangeVariant', {
    pimProductId: pimProductId,
    configName: configName,
    version: 'jlds',
    duration: getDurationFor('quickViewChangeVariant')
  });
}
function dispatchNewRelicAddToBasketEvent(pimProductId, variantId, configName) {
  addPageAction('quickViewAddToBasket', {
    pimProductId: pimProductId,
    variantId: variantId,
    configName: configName,
    version: 'jlds',
    duration: getDurationFor('quickViewAddToBasket')
  });
}
function getDurationFor(eventName) {
  var _window;
  var duration;
  if (typeof ((_window = window) === null || _window === void 0 || (_window = _window.performance) === null || _window === void 0 ? void 0 : _window.mark) === 'function') {
    var performanceEntries = performance.getEntriesByName("".concat(eventName, "-start"));
    if (performanceEntries.length > 0) {
      performance.mark("".concat(eventName, "-complete"));
      var measure = performance.measure("".concat(eventName, "-duration"), "".concat(eventName, "-start"), "".concat(eventName, "-complete"));
      duration = measure === null || measure === void 0 ? void 0 : measure.duration;

      // clean up
      performance.clearMeasures("".concat(eventName, "-duration"));
      performance.clearMarks("".concat(eventName, "-start"));
      performance.clearMarks("".concat(eventName, "-complete"));
    }
  }
  return duration;
}
var addPageAction = function addPageAction(action, parameters) {
  var _window2;
  if (typeof ((_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.newrelic) === null || _window2 === void 0 ? void 0 : _window2.addPageAction) === 'function') {
    var _window$newrelic;
    (_window$newrelic = window.newrelic) === null || _window$newrelic === void 0 || _window$newrelic.addPageAction(action, parameters);
  }
};